var map = {
	"./bg.json": 4541,
	"./cs.json": 4540,
	"./da.json": 9593,
	"./de.json": 6477,
	"./el.json": 311,
	"./en.json": 5553,
	"./es.json": 2706,
	"./et.json": 8399,
	"./fi.json": 915,
	"./fr.json": 4554,
	"./id.json": 7763,
	"./it.json": 6851,
	"./ko.json": 8976,
	"./nb.json": 1186,
	"./nl.json": 6164,
	"./pt.json": 4606,
	"./ro.json": 2453,
	"./ru.json": 3715,
	"./sk.json": 3028,
	"./sv.json": 6643,
	"./tr.json": 44,
	"./uk.json": 3882
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6746;